import { baseUrl } from '@percent/partner-dashboard/services/apiPaths'
import { PBPListResponse, PBPResponse } from '@percent/partner-dashboard/services/types/pbpResponses.types'
import {
  DonationServiceCapabilities,
  Donation,
  GetDonationsListProps,
  CreateDonationRequest,
  DonationPartnerConfigResponse
} from './donationService.types'

export type CurrencyInfo = {
  code: string
  createdAt: string
  name: string
  minimum: number
  maximum: number
  defaultValue: number
  symbol: string
  encodedSymbol: string
  minorUnits: number
  flagCode: string
  supportedByStripe: boolean
  updateAt: string
}

export const donationService = ({ percentClient }: DonationServiceCapabilities) => ({
  getDonationList: (params: GetDonationsListProps) => {
    const filteredParams = {
      ...params,
      ...(params?.fundraiserId && { fundraiserId: params.fundraiserId }),
      ...(params?.status && { status: params.status }),
      ...(params?.kinds && { kinds: params.kinds }),
      ...(params?.query && { query: params.query }),
      ...(params?.category && { category: params.category }),
      excludeImported: true
    }

    const config = Object.keys(filteredParams).length > 0 ? { params: filteredParams } : {}

    return percentClient.get<PBPListResponse<Donation>>(`${baseUrl}donations`, config)
  },
  getCurrencyInfo: () => percentClient.get<PBPListResponse<CurrencyInfo>>(`${baseUrl}currencies`),
  createDonation: (payload: CreateDonationRequest) =>
    percentClient.post<PBPResponse<Donation>>(`${baseUrl}donations`, payload),
  getPartnerConfig: () => percentClient.get<DonationPartnerConfigResponse>(`${baseUrl}partner/donation/config`)
})
